import { Base64Encode } from "./Base64Encode"

export function Base64URLEncode(data: Uint8Array): string {
  const base64 = Base64Encode(data)
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "")
}
